module.exports = __webpack_public_path__ + "img/img-illust-workout.6c2d3f0b.svg";